module.exports = __webpack_public_path__ + "img/blackBack.95633df1.svg";